import BaseRoute from 'volta/routes/base';

import { inject as service } from '@ember/service';

import type IntlService from 'ember-intl/services/intl';
import type DashboardStatsService from 'volta/services/dashboard-stats';
import type CustomFieldDefinitionsService from 'volta/services/custom-field-definitions-service';
import type Transition from '@ember/routing/-private/transition';

export default class DashboardRoute extends BaseRoute {
  @service intl!: IntlService;
  @service dashboardStats!: DashboardStatsService;
  @service customFieldDefinitionsService!: CustomFieldDefinitionsService;

  resourceName = {
    singular: 'dashboard',
    plural: 'dashboard'
  };

  queryParams = {
    q: { refreshModel: true },
    sort: { refreshModel: true },
    warehouse: { refreshModel: true },
    supplier: { refreshModel: true },
    deliveryWorkshop: { refreshModel: true },
    workshop: { refreshModel: true },
    acqCode: { refreshModel: true },
    tags: { refreshModel: true },
    planner: { refreshModel: true },
    buyer: { refreshModel: true },
    timePeriod: { refreshModel: true },
    timePeriodCount: { refreshModel: true },
    methodology: { refreshModel: true },
    customFields: { refreshModel: true },
    page: { refreshModel: true },
    pageSize: { refreshModel: true },
    isBuffered: { refreshModel: true },
    isActive: { refreshModel: true }
  };

  async beforeModel(transition: Transition): Promise<any> {
    await super.beforeModel(transition);
    await this.customFieldDefinitionsService.fetchSkusDefinitions();
  }

  setDocumentTitle() {
    this.documentTitle = ['dashboardPage.title'];
  }
}
